import {
  Button,
  Card,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@sfc/ui";
import { ArrowRightIcon, CheckCircleIcon } from "lucide-react";

export function RoundWizardComplete({
  roundId,
  isSfcRound,
}: {
  roundId: string;
  isSfcRound: boolean;
}) {
  // SFC rounds land on the Members admin page to keep setting up; non-SFC
  // rounds don't have that page, so they go to Round Settings instead.
  const { href, label } = isSfcRound
    ? {
        href: `/round/${roundId}/admin/round-members`,
        label: "Go to Round Members",
      }
    : {
        href: `/round/${roundId}/settings/round`,
        label: "Go to Round Settings",
      };
  return (
    <Card>
      <CardHeader className="flex flex-col items-center text-center">
        <div className="rounded-full bg-green-100 p-4 mb-6">
          <CheckCircleIcon className="size-8 text-green-600" />
        </div>
        <CardTitle>Setup Complete!</CardTitle>
        <CardDescription>
          You've successfully set up your funding round in S-Process.
        </CardDescription>
      </CardHeader>
      <CardFooter className="flex justify-center">
        <Button nativeButton={false} render={<a href={href} />}>
          {label}
          <ArrowRightIcon className="size-4" />
        </Button>
      </CardFooter>
    </Card>
  );
}
